

































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {ChatbotSession} from "@/model/chatbot-session";
import {Page} from "@/model/page";
import {logService} from "@/services/logs";
import moment from "moment";
import BrandIcon from "@/components/BrandIcon.vue";
@Component({
  components: {BrandIcon}
})
export default class WhatsAppList extends Vue {
  pageSize = 10;
  page = 1;
  loading = true
  serverItemsLength = 0;

  sessionsPage: Page<ChatbotSession> = new Page<ChatbotSession>();

  async mounted() {
    await this.onPageChange();
  }

  @Watch('page')
  @Watch('pageSize')
  async onPageChange() {
    this.loading = true;
    this.sessionsPage = await logService.getSessionPage(this.page - 1,this.pageSize);
    this.serverItemsLength = this.sessionsPage.totalElements;
    this.loading = false;
  }

  toPrettyDate(num: number) {
    return moment(num).format('D/MM/YYYY, h:mm a');
  }

  get items() {
    return this.sessionsPage.content
  }

  get _headers() {
    return [
      {
        text: 'Brand',
        value: 'brand',
      },
      {
        text: 'Id',
        value: 'id',
      },
      {
        text: 'Msisdn',
        value: 'msisdn'
      },
      {
        text: 'Last Message Day (DD/MM/YYYY)',
        value: 'lastMessageDate'
      },
      {
        text: 'Link',
        value: 'link'
      }
    ];
  }

}
